import React from 'react';
import { FaGithub } from 'react-icons/fa';
import '../styles/GitHubButtonOfficial.css';

const EnhancedGitHubButton = () => {
  const repoUrl = "https://github.com/AmpyFin/AmpyFin";

  return (
    <a
      href={repoUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="github-compact-button"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="github-section">
        <FaGithub size={16} />
        <span>GitHub</span>
      </div>
    </a>
  );
};

export default EnhancedGitHubButton; 